/* Campaign image carousel — chevron control.
   The scrolling itself is native; this only moves the track by exactly one
   item per press and decides whether each chevron should exist.

   Deliberately not a slider library: the track is a scroll container, so
   momentum, trackpads, keyboard and mobile swipe all work with no help. */
(function () {
  'use strict';

  function init(root) {
    if (root.dataset.clayCarousel === 'ready') return;
    root.dataset.clayCarousel = 'ready';

    var track = root.querySelector('[data-clay-track]');
    var prev = root.querySelector('[data-clay-prev]');
    var next = root.querySelector('[data-clay-next]');
    if (!track || !prev || !next) return;

    function step() {
      var item = track.querySelector('.clay-carousel__item');
      // Measured, not assumed: the item box includes whatever gap is applied.
      return item ? item.getBoundingClientRect().width : track.clientWidth / 2;
    }

    function sync() {
      var max = track.scrollWidth - track.clientWidth;
      // 2px of slack: sub-pixel layout means scrollLeft rarely hits 0 or max exactly.
      prev.hidden = track.scrollLeft <= 2;
      next.hidden = track.scrollLeft >= max - 2;
    }

    prev.addEventListener('click', function () {
      track.scrollBy({ left: -step(), behavior: 'smooth' });
    });

    next.addEventListener('click', function () {
      track.scrollBy({ left: step(), behavior: 'smooth' });
    });

    /* Lazy loading, in two stages.

       Every image ships loading="lazy", so nothing at all is fetched while the
       carousel is far down the page. The catch is that native lazy loading only
       understands the VIEWPORT: all fifteen images sit inside the viewport's
       vertical band once the section is on screen, and the browser has no idea
       that twelve of them are parked off to the right of a scroll container.
       Chrome is conservative and leaves them alone, which is right until you
       press the chevron and arrive at a frame that has not started loading.

       So: stage one watches the SECTION against the viewport and does nothing
       until it is within 300px. Stage two then watches each image against the
       TRACK, with 200% of horizontal slack, and promotes anything within about
       two screens of the scroll position to loading="eager", which starts the
       fetch immediately. Flipping the attribute is the whole mechanism - there
       is no src swapping and no placeholder bookkeeping.

       Both observers disconnect once they have done their work, so an idle
       carousel costs nothing. Without IntersectionObserver the images simply
       stay lazy and the browser decides, which is a fine outcome. */
    function preloadAhead() {
      var imgs = track.querySelectorAll('img[loading="lazy"]');
      if (!imgs.length) return;

      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            entry.target.loading = 'eager';
            io.unobserve(entry.target);
          });
          if (!track.querySelectorAll('img[loading="lazy"]').length) io.disconnect();
        },
        { root: track, rootMargin: '0px 200% 0px 200%', threshold: 0 }
      );

      imgs.forEach(function (img) { io.observe(img); });
    }

    if ('IntersectionObserver' in window) {
      var near = new IntersectionObserver(
        function (entries) {
          if (!entries[0].isIntersecting) return;
          near.disconnect();
          preloadAhead();
        },
        { rootMargin: '300px 0px' }
      );
      near.observe(root);
    }

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { sync(); ticking = false; });
    }, { passive: true });

    if (window.ResizeObserver) new ResizeObserver(sync).observe(track);
    window.addEventListener('resize', sync);
    sync();
  }

  function boot() {
    document.querySelectorAll('[data-clay-carousel]').forEach(init);
  }

  boot();
  document.addEventListener('DOMContentLoaded', boot);
  // Theme editor: sections are re-rendered rather than reloaded.
  document.addEventListener('shopify:section:load', boot);
})();
